// src/dashboard/AddUser.jsx

import React, { useState, useContext } from 'react';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../config/firebaseConfig';
import { AuthContext } from '../context/AuthContext';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function AddUser() {
  const intl = useIntl();
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    cpf: '',
    creci: '',
    whatsapp: '',
    role: 'editor', // default
  });

  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email) {
      toast.error('Nome e email são obrigatórios.');
      return;
    }
    setSaving(true);

    try {
      const newUser = {
        ...formData,
        accountType: user?.accountType || '',
        parentId: user?.uid || null,
        createdAt: serverTimestamp(),
        active: true,
      };

      await addDoc(collection(db, 'users'), newUser);
      toast.success('Usuário adicionado com sucesso!');
      navigate('/dashboard/users');
    } catch (error) {
      console.error('Erro ao adicionar usuário:', error);
      toast.error('Erro ao adicionar usuário.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="dashboard-content">
      <h2>{intl.formatMessage({ id: 'user.addTitle' })}</h2>
      <p className="section-subtitle">{intl.formatMessage({ id: 'user.addUserInfo' })}</p>

      <form className="form-grid" onSubmit={handleSubmit} style={{ maxWidth: '700px', marginTop: '2rem' }}>
        <div className="form-group">
          <label>{intl.formatMessage({ id: 'form.name' })}</label>
          <input name="name" value={formData.name} onChange={handleChange} className="input-field" required />
        </div>
        <div className="form-group">
          <label>{intl.formatMessage({ id: 'user.email' })}</label>
          <input name="email" type="email" value={formData.email} onChange={handleChange} className="input-field" required />
        </div>
        <div className="form-group">
          <label>CPF</label>
          <input name="cpf" value={formData.cpf} onChange={handleChange} className="input-field" />
        </div>
        <div className="form-group">
          <label>CRECI</label>
          <input name="creci" value={formData.creci} onChange={handleChange} className="input-field" />
        </div>
        <div className="form-group">
          <label>{intl.formatMessage({ id: 'user.whatsapp' })}</label>
          <input name="whatsapp" value={formData.whatsapp} onChange={handleChange} placeholder={intl.formatMessage({ id: 'user.whatsappPlaceholder' })} className="input-field" />
        </div>
        <div className="form-group">
          <label>{intl.formatMessage({ id: 'user.role' })}</label>
          <select name="role" value={formData.role} onChange={handleChange} className="input-field">
            <option value="editor">Editor</option>
            <option value="corretor">Corretor</option>
            <option value="suporte">Suporte</option>
          </select>
        </div>
        <div className="form-actions" style={{ gridColumn: '1 / -1' }}>
          <button type="button" onClick={() => navigate('/dashboard/users')} className="secondary-button">{intl.formatMessage({ id: 'general.cancel' })}</button>
          <button type="submit" className="primary-button" disabled={saving}>{saving ? intl.formatMessage({ id: 'general.saving' }) : intl.formatMessage({ id: 'general.save' })}</button>
        </div>
      </form>
    </div>
  );
}